import { useSyncExternalStore } from "react"

type ThresholdResult = "above" | "below" | "equal"

export function useScreenWidthThreshold(thresholdPixels: number): ThresholdResult {
    const equalQuery = `(width: ${thresholdPixels}px)`
    const belowQuery = `(max-width: ${thresholdPixels - 1}px)`

    const getSnapshot = (): ThresholdResult => {
        if (typeof window === "undefined") return "above" // Server-side rendering fallback
        if (window.matchMedia(equalQuery).matches) return "equal"
        if (window.matchMedia(belowQuery).matches) return "below"
        return "above"
    }

    const subscribe = (callback: () => void) => {
        const equalMedia = window.matchMedia(equalQuery)
        const belowMedia = window.matchMedia(belowQuery)
        equalMedia.addEventListener("change", callback)
        belowMedia.addEventListener("change", callback)
        return () => {
            equalMedia.removeEventListener("change", callback)
            belowMedia.removeEventListener("change", callback)
        }
    }

    return useSyncExternalStore(subscribe, getSnapshot, () => "above")
}
